import { createContext, useContext, useEffect, useState } from "react";
import { getUserProfile } from "../services/Apis";

const FilterContext = createContext();

export const FilterProvider = ({ children }) => {
    // Synchronously read the token from cookies
    const getInitialToken = () => {
        const match = document.cookie.match(/(?:^|;\s*)token=([^;]*)/);
        return match ? decodeURIComponent(match[1]) : "";
    };

    const [token, setToken] = useState(getInitialToken());
    const [isLoggedIn, setIsLoggedIn] = useState(!!getInitialToken());
    const [profile, setProfile] = useState({ name: "", phone: "", email: "", image: "" });

    // Other states
    const [category, setCategory] = useState(null);
    const [subCategory, setSubCategory] = useState(null);
    const [price, setPrice] = useState("");
    const [search, setSearch] = useState("");

    // Now fetch the profile based on token
    useEffect(() => {
        const fetchProfile = async () => {
            if (token) {
                const user = await getUserProfile(token);
                if (user) {
                    setProfile({
                        name: user.name || "",
                        phone: user.phoneNumber || "",
                        email: user.email || "",
                        image: user.imageUrl || ""
                    });
                    setIsLoggedIn(true);
                } else {
                    setIsLoggedIn(false);
                }
            }
        };

        fetchProfile();
    }, [token]);

    return (
        <FilterContext.Provider
            value={{
                category, setCategory,
                subCategory, setSubCategory,
                price, setPrice,
                search, setSearch,
                profile, setProfile,
                isLoggedIn, setIsLoggedIn,
                token, setToken
            }}
        >
            {children}
        </FilterContext.Provider>
    );
};


export const useFilter = () => useContext(FilterContext);
